//#region Styles
import { 
    LinkA, Row } from "components/styles";
import { Content } from "./styles";
//#endregion
//#region Components
//#endregion
//#region Images
//#endregion
//#region Services
//#endregion
//#region Utils
//#endregion

const LocationDataField = ({
    location,
    zoomLink
}) => {
    if (!location) 
        return (
            <Content>
                <span>{"-"}</span>
            </Content>
        );
    const { id, name, icon } = location;
    return (
        <Content>
            <Row className="flex-start" rowGap="6px" columnGap="8px">
                <img src={icon} alt={name}/>
                <span>{name}</span>
                {id === 1 && 
                    <span>
                        * Los links serán generados automáticamente
                    </span>}
            </Row>
            {zoomLink && 
            <LinkA 
                title={zoomLink} 
                href={zoomLink} 
                target="_blank">{zoomLink}</LinkA>}
        </Content>
    );
}

export default LocationDataField;